var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-0 mb-0 guest-ui"},[_c('transition',{attrs:{"name":"slide-vertical"}},[(
				!_vm.isPrivateTour &&
					!_vm.enableRateDuration &&
					!_vm.isPackage &&
					!_vm.DisableLargeGroup
			)?_c('hgroup',{staticClass:"flex mb-2"},[_c('div',{staticClass:"mb-0"},[_c('p',{staticClass:"mb-0 mt-0",staticStyle:{"font-weight":"500"}},[_vm._v("\n\t\t\t\t\tI need more than "+_vm._s(_vm.maxPeople)+"\n\t\t\t\t\t"+_vm._s(_vm.activeProductDetails.OverrideRateLabel
							? _vm.maxPeople == 1
								? _vm.activeProductDetails.RateLabelSingular
								: _vm.activeProductDetails.RateLabelPlural
							: _vm.maxPeople != 1
							? 'guests'
							: 'guest')+"\n\t\t\t\t\t"),_c('br'),(!_vm.isPackage && !_vm.DisableLargeGroup)?_c('small',{staticClass:"text-pencil"},[_vm._v("Book over multiple time slots")]):_vm._e()])]),(!_vm.isPackage && !_vm.DisableLargeGroup)?_c('div',[_c('toggle',{attrs:{"name":'IsLargeGroup_toggle'},model:{value:(_vm.activeProductDetails.IsLargeGroup),callback:function ($$v) {_vm.$set(_vm.activeProductDetails, "IsLargeGroup", $$v)},expression:"activeProductDetails.IsLargeGroup"}})],1):_vm._e()]):_vm._e()]),_c('pre',[_vm._v("totalGuestInActivity: "+_vm._s(_vm.totalGuestInActivity))]),_c('pre',[_vm._v("totalGuestInPackage: "+_vm._s(_vm.totalGuestInPackage))]),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.IsLargeGroup && !_vm.enableRateDuration),expression:"!IsLargeGroup && !enableRateDuration"}],staticClass:"button large _shadow outline mb-2",class:{
			'bg-mist': _vm.totalGuestInActivity,
			'scale-animation': !_vm.totalGuestInActivity,
			'border-red':
				_vm.totalGuestInActivity != _vm.totalGuestInPackage &&
				_vm.totalGuestInActivity &&
				_vm.isPackage &&
				!_vm.isPrivateTour,
		},attrs:{"disabled":_vm.disabled,"to":_vm.disabled ? '#' : 'guests/' + _vm.entityHierarchyKey,"activeClass":"active"}},[(_vm.totalGuestInActivity)?_c('span',{staticClass:"flex"},[_c('span',{staticClass:"-text-medium"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.totalGuestInActivity)+"\n\t\t\t\t"),(
						_vm.totalGuestInActivity != _vm.totalGuestInPackage &&
							_vm.isPackage &&
							!_vm.isPrivateTour
					)?_c('span',[_vm._v("of "+_vm._s(_vm.totalGuestInPackage))]):_vm._e(),_vm._v("\n\t\t\t\t"+_vm._s(_vm.activeProductDetails.OverrideRateLabel
						? _vm.totalGuestInActivity == 1
							? _vm.activeProductDetails.RateLabelSingular
							: _vm.activeProductDetails.RateLabelPlural
						: _vm.totalGuestInActivity != 1
						? 'guests'
						: 'guest')+"\n\t\t\t")]),_c('small',{staticClass:"text-blue"},[_vm._v("Edit")])]):_c('span',{staticClass:"text-blue"},[_vm._v(_vm._s(_vm.isPackage ? 'Assign ' : 'Add ')+"\n\t\t\t"+_vm._s(_vm.activeProductDetails.OverrideRateLabel
					? _vm.activeProductDetails.RateLabelPlural
					: 'guests'))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }